import { DCarbonizeAppConfig } from 'app/@types/shared/app-config';

export const environment: DCarbonizeAppConfig = {
    apiUrl: 'https://scan-test.carbon-cockpit.eu/api',
    // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-unsafe-member-access
    appVersion: require('../../package.json').version + '-test',
    client: {
        clientConfig: false,
        name: 'Dcarbonize',
        support: {
            mailDcarbonize: 'scan@d-carbonize.eu',
        },
    },
    cognitoAppClientId: '4o326cjj7277etm92f9qekoukp',
    cognitoRegion: 'eu-west-3',
    cognitoUserPoolId: 'eu-west-3_t2hhmWWyK',
    cookieStorage: {
        domain: 'scan-test.carbon-cockpit.eu',
        expires: 31,
        path: '/',
        sameSite: 'strict',
        secure: true,
    },
    debug: {
        tracing: false,
    },
    defaultLocale: 'en',
    domain: 'scan-test.carbon-cockpit.eu',
    hmr: false,
    oauth: {
        domain: '',
        redirectSignIn: 'https://scan-test.carbon-cockpit.eu/auth/login',
        redirectSignOut: 'https://scan-test.carbon-cockpit.eu/auth/logout',
        scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    },
    production: false,
    registerAllowed: true,
    showVideoOnboarding: true,
    supportedLanguages: ['en', 'fr', 'nl'],
};
